import React, { Component } from 'react'
import {StyleSheet, View, Platform} from 'react-native'
import { JDText, JDTouchable, JDDevice, JDMta, JDImage } from '@jdreact/jdreact-core-lib'

import PropTypes from "prop-types"
import arrowDownImg from '../../../images/detail/arrow-down.png'
import arrowUpImg from '../../../images/detail/arrow-up.png'

const propTypes = {
	houseDesItem: PropTypes.object,
	cityId: PropTypes.number
};
export default class HouseDesItem extends Component {
	static contextTypes = {
		router: PropTypes.object
	};
	constructor() {
		super();
		this.state = {
			numLines: null,
			isMoreThan: false, // 所传的文字是否超过三行
			isMore: false,
			maxHeight: null
		}
	}
	isHouseDesPage = () => { // 判断是否是房源描述页
		if (Platform.OS === 'web') {
			if (window.location.pathname == "/houseDes")  return true;
		} else {
			let routes = this.context.router.getCurrentRoutes();
			if(routes[routes.length-1].routeName == "houseDes") return true;
		}
		return false;
	};
	render() {
		let {houseDesItem, cityId} = this.props;
		return (
			<View style={desStyles.desBox}>
				<JDText
					style={desStyles.detailContent}
					numberOfLines={this.state.isMore ? null : this.state.numLines}
					onLayout={(event)=>{
						let height = event.nativeEvent.layout.height;
						if(this.state.maxHeight === null){
							this.setState({
								maxHeight: height,
								numLines: 3
							});
						} else {
							if(this.state.maxHeight > height){
								this.setState({
									isMoreThan: true
								});
							}
						}
					}}
				>{houseDesItem.content}</JDText>
				<View>
					{
						this.state.isMore &&
						<JDTouchable onPress={() => {
							let isHouseDesPage = this.isHouseDesPage();
							let eventId = isHouseDesPage ? "SHouse_HouseDescribeListFold" : "SHouse_HouseDescribeFold";
							let pageId = isHouseDesPage ? "SHouse_HouseDescribeList" : "SHouse_HouseDetail";
							JDMta.sendClickData(eventId, cityId+"",	"", 	"",	"",	"", pageId,	"");
							this.setState({isMore: !this.state.isMore})
						}}>
							<View style={desStyles.btnWrapper}>
								<JDText style={desStyles.btn}>收起</JDText>
								<JDImage source={arrowUpImg} style={desStyles.arrow}></JDImage>
							</View>
						</JDTouchable>
					}
					{
						!this.state.isMore && this.state.isMoreThan &&
						<JDTouchable onPress={() => {
							let isHouseDesPage = this.isHouseDesPage();
							let eventId = isHouseDesPage ? "SHouse_HouseDescribeListUnfold" : "SHouse_HouseDescribeUnfold";
							let pageId = isHouseDesPage ? "SHouse_HouseDescribeList" : "SHouse_HouseDetail";
							JDMta.sendClickData(
									eventId, // event_id
									cityId+"", // event_param
									"", // event_func,点击事件函数名称
									"", // page（空字符串），点击当前页面对象，如activity，fragment
									"", // page_param,当前页面参数
									"", // next_page_param（空字符串），跳转到下一个页面的类
									pageId, // page_id
									"", // shop_id
							);
							this.setState({isMore: !this.state.isMore})
						}}>
							<View style={desStyles.btnWrapper}>
								<JDText style={desStyles.btn}>展开</JDText>
								<JDImage source={arrowDownImg} style={desStyles.arrow}></JDImage>
							</View>
						</JDTouchable>
					}
					{/* <JDText style={desStyles.companyDes}>{houseDesItem.companyDes}发布</JDText> */}
				</View>
			</View>
		)
	}
}
const desStyles = StyleSheet.create({
	desBox: {
		// marginHorizontal: JDDevice.getRpx(30)
	},
	detailContent: {
		width: '100%',
		// textAlign: 'justify',
		lineHeight: JDDevice.getRpx(42),
		color: '#1a1a1a',
		fontSize: JDDevice.getFontSize(28),
		justifyContent: 'space-between',
		marginBottom: JDDevice.getRpx(20),
	},
	btn: {
		color: '#555555',
		fontSize: JDDevice.getFontSize(24),
		textAlign: 'right',
		fontFamily: "PingFang SC",
		fontWeight: 'normal',
		lineHeight: JDDevice.getRpx(40)
	},
	companyDes: {
		marginBottom: JDDevice.getRpx(40),
		color: '#848689',
		textAlign: 'right',
		fontSize: JDDevice.getFontSize(28)
	},
	btnWrapper:{
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginBottom: JDDevice.getRpx(28),
	},
	arrow:{
		width: JDDevice.getRpx(40),
		height: JDDevice.getRpx(40),
	}
});
